export default __webpack_public_path__ + "static/media/paralympics_sports.00f7c6a6.csv";